import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import APIRequest from "../../../Services/commonAPIConsumer";
// import { useCookies } from "react-cookie";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import LoginDataService from "../../../Services/LoginService";
import Alert from "../../Controls/Alerts/Alerts";
import { AppContext } from "../../../AppContext";

function SSOSignIn(props) {
  const [openLoader, setOpen] = useState(true); // Loader state

  const location = useLocation();
  const data = location.state?.data; // Accessing the passed data
  const ssovar = location.state?.SSOVar;
  const [alertMsg, setAlertMsg] = useState("");
  const [IsErrorMsg, setIsErrorMsg] = useState(false);
  const [alertType, setAlertType] = useState("");
  const history = useNavigate();
  //   const [cookies, setUserNameCookie] = useCookies([""]);
  //   const [signCookie, settabCookie] = useCookies([""]);
  //   settabCookie("TabSSOSignIn", "SSOSignIn");
  //   let UserName = getCookie("UserName");
  // let UserTabSend = getCookie("TabSend");
  // let UserTabSignIn = getCookie("TabSignIn");
  // let UserTabSSOSignIn = getCookie("TabSSOSignIn");
  // let UserTabCreate = getCookie("TabCreate");
  // let UserTabDocumentHistory = getCookie("TabDocumentHistory");

  // if (window.performance) {
  //   if (performance.navigation.type == 1) {
  //     settabCookie("TabSSOSignIn", "Referesh");
  //   }
  // }
  // function getCookie(name) {
  //   var nameEQ = name + "=";
  //   var ca = document.cookie.split(";");
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == " ") c = c.substring(1, c.length);
  //     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  //   }
  //   return null;
  // }

  useEffect(() => {
    if (ssovar == true)
      SSOLoginClick();
  }, []);
  useEffect(() => {
    const receiveMessage = (event) => {
      console.log("window.addEventListener:" + window.addEventListener);
      console.log("Message received from parent:", event.data);
      let data = event.data;

      if (data && JSON.stringify(data).indexOf('accesstoken') !== -1) {
        localStorage.setItem("SSOData", event.data);
      }
      else if (data && JSON.stringify(data).indexOf('errorReason') !== -1) {

        setAlertMsg("You have closed login popup");
        setAlertType("warning");
        return;
      }
      else {

      }
    };
    // Attach the message event listener
    if (window.addEventListener)
      window.addEventListener("message", receiveMessage, false);
    else window.addEventListener("onmessage", receiveMessage, false);

    return () => {
      // Clean up the event listener when the component unmounts
      if (window.addEventListener)
        window.removeEventListener("message", receiveMessage);
      else window.removeEventListener("onmessage", receiveMessage);
    };
  }, []);
  useEffect(() => {
    if (localStorage.getItem("SSOData") != null && localStorage.getItem("SSOData") != undefined) {
      SsoLogin(localStorage.getItem("SSOData"));
      localStorage.removeItem("SSOData");
    }
  })
  //   useEffect(() => {
  //     const handleBeforeUnload = (e) => {
  //         // Clear the cookies when the user is about to unload the page
  //         settabCookie("TabSignIn", "");
  //         settabCookie("TabSSOSignIn", "");
  //         // Prevent the default behavior
  //         e.preventDefault();
  //     };
  //     window.addEventListener('beforeunload', handleBeforeUnload);
  //     // Cleanup the event listener when the component unmounts
  //     return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  // }, []);

  function SSOLoginClick() {
    // const handleBeforeUnload = (e) => {
    //     // Clear the cookies when the user is about to unload the page
    //     settabCookie("TabSignIn", "");
    //     settabCookie("TabSSOSignIn", "");
    //     // Prevent the default behavior
    //     e.preventDefault();
    // };
    // // Attach the event listener for beforeunload
    // window.addEventListener('beforeunload', handleBeforeUnload);

    var RCapAuthenticationUrl = AppContext.RCapAuthenticationUrl;
    var ClientId = AppContext.ClientId;
    var LoginUrl = `${process.env.REACT_APP_DomainUrl}`;
    var CallBackUrl = LoginUrl + process.env.REACT_APP_SSOCallBack;

    localStorage.setItem("rCapAuthenticationUrl", RCapAuthenticationUrl);
    localStorage.setItem("clientId", ClientId);
    localStorage.setItem("domainUrl", LoginUrl);

    var authenticateUrl =
      `${RCapAuthenticationUrl}rpost-authentication?RpostClientId=${ClientId}&CallBackUrl=${CallBackUrl}&LoginUrl=${LoginUrl}`;

    if (localStorage.getItem("showLoginPopup") != null) {
      var showLoginPopup = localStorage.getItem("showLoginPopup");
      if (showLoginPopup === "Y") {
        authenticateUrl += `&ShowLoginPopup=${showLoginPopup}`;
      }
    }

    // Redirect to the authentication URL


    // Cleanup the event listener after redirecting
    //window.removeEventListener('beforeunload', handleBeforeUnload);
    window.location.replace(authenticateUrl);

    return false; // Not strictly necessary; can be omitted
  }

  var UserNameSSO = null;
  async function SsoLogin(data) {
    let dataa = JSON.parse(data);
    //  window.addEventListener("beforeunload", (ev) => {

    //   settabCookie("TabSignIn", "");
    //   ev.preventDefault();
    // });
    if (typeof dataa === "string") {
      dataa = JSON.parse(dataa);
    }
    try {
      var ssoTokenRequestModel = {
        provider_Access_Token: dataa.accesstoken,
        BrowserType: dataa.ssotype,
      };
      var response = await LoginDataService.SSOLogin(JSON.stringify(ssoTokenRequestModel));

      if (response && response === "Server maintenance") {
        return;
      }
      else if (response.status === 200) {
        localStorage.removeItem("DocumentID");
        localStorage.removeItem("ManageItem");
        localStorage.setItem("loginTimerCount", 0);
        localStorage.setItem("refresh_timer_count", 0);
        setOpen(false);
        localStorage.setItem("header", "1");
        localStorage.setItem("UserName", response.data.email);
        localStorage.setItem("language", response.data.language);
        localStorage.setItem(
          "DateControlFormat",
          response.data.dateControlFormat
        );
        // localStorage.setItem('JWtToken', response.data.jwt);
        localStorage.setItem("SSOType", response.data.ssoType);
        localStorage.setItem("UserRole", response.data.userRole);
        localStorage.setItem("Companyname", response.data.companyname);
        // setUserNameCookie("UserName", response.data.email);
        //  settabCookie("TabSSOSignIn", "Signed");
        setAlertType("sucess");
        let landingPage = [];

        landingPage = response.data.landingPage.split("_");

        if (landingPage.length > 1) {
          localStorage.setItem("ManageItem", landingPage[1]);
          history("/history");
          return;
        }

        if (landingPage[0] === "Generate") history("/create");
        else history(`/${landingPage[0]}`);

      }
      else if (response != null) {
        if (
          response.data.errorMessage ==
          "Your account has been blacklisted, please contact the administrator."
        )
          history("/blacklisted");
        else if (
          response.data.errorMessage ==
          "Your account has been suspended, please contact the administrator."
        )
          history("/suspended");
        else if (
          response.data.errorMessage ==
          "No subscription plan is assigned for this account. Please contact your company administrator."
        )
          history("/noplan");
        else {
          setAlertMsg("The session has expired. Please log-in again.");
          setAlertType("warning");
          setTimeout(() => {
            history("/");
          }, 2000);
        }
      } else {
        setOpen(false);
        setAlertMsg("The session has expired. Please log-in again.");
        setAlertType("warning");
        setTimeout(() => {
          history("/");
        }, 2000);
      }

      // Further processing logic here
    } catch (error) {
      // Handle any errors
      // setOpen(false);
      // setAlertMsg("Failed to load document.");
      // setAlertType("warning");
      return;
    }
  };

  return (
    <>
      {openLoader ? <LoadingSpinner /> : null}
      <div className="container-login100">
        {/* alerts */}
        <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg} setAlertType={setAlertType}></Alert>
        {/* end */}

        <img
          className="wave"
          src="assets/img/wave_yellow.svg"
          style={{ color: "f2d8da" }}
          alt="Wave"
        />
        <main className="login_wrapper my2">
          <div className="container">
            <div className="text-center mb-2">
              <img src="assets/img/RDocs.png" className="logo" alt="logo" />
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default SSOSignIn;
